var map = {
	"./affirm/NewsletterComp": [
		"58d5",
		"chunk-3e633834"
	],
	"./au/ACCNewsletterComp": [
		"20c2",
		"chunk-136300bf"
	],
	"./au/AUNewsletterComp": [
		"38c7"
	],
	"./au/NZNewsletterComp": [
		"59e9",
		"chunk-006f4614"
	],
	"./murdoch/NewsletterComp": [
		"361e",
		"chunk-de46ad92"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a006";
module.exports = webpackAsyncContext;